import { useTranslation } from 'react-i18next'

import classNames from '../../utils/classNames'
import Icon from '../icon'

const AboutDeposit = () => {
  const { t } = useTranslation('walletManagement')

  return (
    <span className="relative inline-flex items-center pt-[9px] pb-[7px] px-[7px] group">
      <Icon
        id="outline-exclamation-circle"
        width="15"
        height="15"
        className="mr-1.5 mb-0.5"
      />
      {/* Tooltip */}
      <span
        className={classNames(
          'absolute top-[calc(100%-5px)] left-1/2 -translate-x-1/2 transition-all duration-200 ease-in-out opacity-0 group-hover:opacity-100',
          'bg-highlight rounded p-2.5pointer-events-none [&_p]:text-[13px] lg:[&_p]:text-[15px] [&_p]:text-white [&_p]:whitespace-nowrap',
        )}>
        <p>{t('min-depo')} $100 MXN</p>
        <p>{t('max-depo')} $1,000,000 MXN</p>
      </span>
    </span>
  )
}

export default AboutDeposit
